import { SelectOption } from '../types'

export const storeys = ['Single', 'Two', 'Three']

export const getStoreysOptions = (propertyType: string): SelectOption[] =>
  storeysMap[propertyType]?.map((storey) => ({
    value: storey,
    label: storey,
  })) ?? []

export const storeysMap: Record<string, string[]> = {
  'Standard House': ['Single', 'Two'],
  'Architecturally Designed Home': ['Single', 'Two'],
  Townhouse: ['Two'],
  Units: ['Three'],
  Apartments: ['More than Three less than Eight'],
  'Project Home': ['Single', 'Two'],
  'Project Units': ['Single'],
}
